export class Customer {

    _id: String;
    name: String;
    financialId: String;
    financialName: String;


    loadFromServer(r: any) {
        this._id = r._id;
        this.name = r.name;
        this.financialId = r.financialId;
        this.financialName = r.financialName;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/Customer.model.ts